/**
 * Spinner — the shared brand spinner (2026-08-09, onboarding-clarity pass).
 *
 * Extracted verbatim from the de facto standard on /desktop
 * (AgentActivity.tsx): 28px ring, 2px #E6E6E6 track, gold #C6A75E head,
 * 0.9s linear spin. Many pages still carry private copies of this exact
 * spinner — new code should use this one; existing copies are left alone
 * deliberately (no drive-by refactors of live surfaces).
 */

import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div<{ $size?: number; $track?: string }>`
  width: ${({ $size }) => $size ?? 28}px;
  height: ${({ $size }) => $size ?? 28}px;
  border-radius: 50%;
  /* $track: dark surfaces pass a translucent light track (the default
     #E6E6E6 track reads as a solid disc on black). Head stays house gold. */
  border: 2px solid ${({ $track }) => $track ?? 'var(--brand-line)'};
  border-top-color: var(--brand-gold);
  animation: ${spin} 0.9s linear infinite;
  flex-shrink: 0;
`;

export default Spinner;
